import React, { Component } from 'react';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';

// Dynamic Imports 
const SubNavigation = dynamic(() => import('../SubNavigation/SubNavigation'));

export default class MainMenu extends Component {
  getLink(item) {
    if (item.categories.length === 0) {
      return `/category/${item.slug}`;
    }
    return null;
  }

  findCategoryById(id) {
    const {
      navigation
    } = this.props;

    const category = navigation && navigation.entities.categories.find(
      cat => cat.id === id
    );
    return category;
  }

  render() {
    const s = require('./Menu.module.scss');
    const { onClick, navigation } = this.props;
    const list = navigation && navigation.entities.sections;

    return (
      <div className={s.MainMenu}>
        <div className={s.FixedHeader} />
        <ul className={s.Level1}>
          {list && list.length > 0 && list.map(section => (
            <SubNavigation
              key={section.id}
              index={section.id}
              item={{ ...section, link: this.getLink(section) }}
              level={1}
              onClick={onClick}
            >
              <ul className={s.Level2}>
                {section.categories.map((id) => {
                  const cat = this.findCategoryById(id);
                  return (
                    cat && (
                      <SubNavigation
                        key={cat.id}
                        item={{ ...cat, link: this.getLink(cat) }}
                        level={2}
                        onClick={onClick}
                      >
                        <ul className={s.Level2}>
                          {cat.categories.map((index) => {
                            const subCat = this.findCategoryById(index);
                            return (
                              subCat && (
                                <SubNavigation
                                  key={subCat.id}
                                  index={index}
                                  item={{
                                    ...subCat,
                                    link: this.getLink(subCat),
                                  }}
                                  level={3}
                                  onClick={onClick}
                                />
                              )
                            );
                          })}
                        </ul>
                      </SubNavigation>
                    )
                  );
                })}
              </ul>
            </SubNavigation>
          ))}
        </ul>
      </div>
    );
  }
}

MainMenu.propTypes = {
  onClick: PropTypes.func,
  navigation: PropTypes.object,
};